import React, { useEffect } from "react";
import { Form, Select } from "antd";
import { useIntl } from "react-intl";
import { getTemplates } from "../ClientsSlice";
import { setActiveTemplate } from "../../clientDetails/clientDetailsSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getFormItemLabel,
  getFormItemVaidation,
} from "../../../components/util/helpers";
const { Option } = Select;

const TemplateSelection = () => {
  const templates = useSelector((state) => state.clients.templates.items);
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTemplates());
  }, [dispatch, templates.length]);

  const onChange = (value) => {
    dispatch(setActiveTemplate({ record: templates[value] }));
  };

  const label = getFormItemLabel(intl, "employee", "employee_type_id", null);
  const arr = ["required"];
  const rules = getFormItemVaidation(intl, label, arr);

  return (
    <Form.Item
      name={"template"}
      rules={rules}
      wrapperCol={{ span: 24 }}
      style={{
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <Select
        showSearch
        placeholder={intl.formatMessage({
          id: "app.clients.customersList",
        })}
        optionFilterProp="children"
        onChange={onChange}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {templates.map((template, i) => {
          return (
            <Option value={i} key={template.id}>
              {template.name}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

export default TemplateSelection;
